export const hasLoadingData = (dataList: unknown): boolean => {
  if (dataList === null || dataList === undefined) {
    return false;
  }

  if (Array.isArray(dataList) || typeof dataList === "string") {
    return dataList.length > 0;
  }

  if (dataList instanceof Map || dataList instanceof Set) {
    return dataList.size > 0;
  }

  if (typeof dataList === "object") {
    return Object.keys(dataList).length > 0;
  }

  return Boolean(dataList);
};

export const isLoadingDataEmpty = (dataList: unknown): boolean =>
  !hasLoadingData(dataList);
